import { useContext } from 'react';
import { DetailsPanelDisplayContext } from '../contexts/DetailsPanelDisplay.context';

export const useDetailsPanelDisplay = () => useContext(DetailsPanelDisplayContext);
